import { createContext, useCallback, useContext, useEffect, useState } from "react";
import api, { apiError, getCompanyId, setCompanyId } from "@/lib/api";
import { FullScreenLoader } from "@/components/FullScreenLoader";
import { applyBrand } from "@/lib/pwa";

export const CompanyContext = createContext(null);

export function CompanyProvider({ children }) {
  const [company, setCompany] = useState(null);
  const [logoUrl, setLogoUrl] = useState(null);
  const [lightLogoUrl, setLightLogoUrl] = useState(null);
  const [error, setError] = useState("");

  const reload = useCallback(async () => {
    try {
      const { data } = await api.get("/company");
      setCompany(data);
      applyBrand(data.slug, data.name);
      if (data.has_logo) {
        const get = (variant) => api.get("/company/logo", { params: { variant, v: data.logo_version }, responseType: "blob" }).then((r) => URL.createObjectURL(r.data));
        const [dark, light] = await Promise.all([get("dark"), get("light")]);
        setLogoUrl(dark);
        setLightLogoUrl(light);
      } else { setLogoUrl(null); setLightLogoUrl(null); }
    } catch (e) {
      if (getCompanyId() && [400, 404].includes(e.response?.status)) {
        setCompanyId(null);
        window.location.reload();
        return;
      }
      setError(apiError(e));
    }
  }, []);

  useEffect(() => { reload(); }, [reload]);

  const switchCompany = (id, to = "/dashboard") => {
    setCompanyId(id);
    window.location.assign(to);
  };

  if (error) return <div className="p-10 text-red-600" data-testid="company-error">{error}</div>;
  if (!company) return <FullScreenLoader />;
  return <CompanyContext.Provider value={{ company, logoUrl, lightLogoUrl, reload, switchCompany }}>{children}</CompanyContext.Provider>;
}

export const useCompany = () => useContext(CompanyContext);
